import { FormError } from 'baseApi';

export class WondeLinkStatusError {
  public static parseError = (errors: any) => {
    let error: string;
    switch (errors[0].messageCode) {
      case 'Invalid_Access':
        error = 'Invalid access';
        break;
      case 'Required':
        error = 'This is required';
        break;        
      default:
        error = 'Sorry something went wrong. Please try again.';
    }
    return error;
  };
};

export class WonderParser {};

export type SyncWondeDataResponse = {
  nonConformingPupils: string[];
  nonConformingSchoolUsers: string[];
  bWondeMisChange: boolean;
  misChangeMessage: string | null;
};

export const AUTOMATICALLY_SKIPPED_CODE = 'Automatically_Skipped';
export const MIS_CHANGE_NOT_FOUND_CODE = 'Mis_Change_Not_Found';

export const hasWondeMessageCode = (errors: FormError[] | undefined, messageCode: string) =>
  !!errors?.some((error) => error.messageCode === messageCode);

export type MisChangeAnswerResponse = {
  schoolAccountsWondeMisLogId: number;
  // Null while the second warning is showing, nothing is saved until then
  bConfirmedMisChange: boolean | null;
  bWondeMisChange: boolean;
  bShowWarning: boolean;
  warningMessage: string | null;
};

export type ClassesMisMatchClass = {
  classesId: number;
  className: string | null;
  applicableYear: string | null;
  keyStage: string | null;
  suggestedWondeClassesApplicableYearsId: number | null;
};

export type ClassesMisMatchWondeClass = {
  wondeClassesApplicableYearsId: number;
  className: string | null;
  applicableYear: string | null;
  keyStage: string | null;
};

export type ClassesMisMatchResponse = {
  schoolAccountsWondeMisLogId: number;
  previousMis: string | null;
  newMis: string | null;
  bAutomaticallySkipped: boolean;
  classes: ClassesMisMatchClass[];
  wondeClasses: ClassesMisMatchWondeClass[];
};

export type ClassesMisMatchPair = {
  classesId: number;
  wondeClassesApplicableYearsId: number;
};

export type SetClassesMisMatchResponse = {
  schoolAccountsWondeMisLogId: number;
  pairedClasses: number;
  unpairedClasses: number;
  bWondeMisChange: boolean;
};
